module.exports = __webpack_public_path__ + "static/media/icon-phone-comm-log.679fd870.svg";